import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import { Container, Row, Col } from 'reactstrap';
import ListPanel from '../../common/containers/listPanel';
import { editPermissionSelector, viewPermissionSelector } from '../../common/classes/permissions';
import routeHelper from '../../common/classes/routeHelper';
import EmployeesRow from './employeesRow';
import EmployeesPagingTable from './employeesPagingTable';
import entityComposition from '../../common/classes/entityComposition';
import EmployeesFilters from './employeesFilters';
import appHistory from '../../../utils/appHistory';
const handleSelect = id => {
  appHistory.push(`/admin/employees/${id}`);
};
class Employees extends React.Component {
  constructor(props) {
    const {
      employeeActions,
      employee: {
        indexQuery
      }
    } = props;
    super(props);
    employeeActions.serverIndex(indexQuery);
    this.handleNew = this.handleNew.bind(this);
  }
  componentDidMount() {
    const {
      canView,
      location
    } = this.props;
    // Redirect and post authorization error message if permissions insufficient
    routeHelper.handleViewRedirect(canView, location);
  }
  handleNew() {
    const {
      login: {
        user: {
          user_id: appCreatorID
        }
      },
      employeeActions
    } = this.props;
    const id = uuidV4().toUpperCase();
    const employee = {
      id,
      active: 1,
      appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
      appCreatorID,
      mfaEnabled: false,
      assets: [],
      certifications: [],
      jobs: []
    };
    employeeActions.create(id, employee);
    handleSelect(id);
  }
  render() {
    const {
      employee: {
        list,
        loading,
        indexQuery
      },
      canEdit
    } = this.props;
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(EmployeesFilters, null)), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(ListPanel, {
      title: "Employees",
      showNew: canEdit,
      onAdd: this.handleNew
    }, /*#__PURE__*/React.createElement(EmployeesPagingTable, {
      headers: ['Employee Name', 'Username'],
      loading: loading,
      indexQuery: indexQuery,
      hideSortOptions: true
    }, list.map((item, index) => /*#__PURE__*/React.createElement(EmployeesRow, {
      index: index,
      key: item.id,
      id: item.id,
      data: item,
      onClick: handleSelect
    })))))));
  }
}
Employees.propTypes = {
  employeeActions: PropTypes.shape({
    add: PropTypes.func,
    change: PropTypes.func,
    changeSection: PropTypes.func,
    remove: PropTypes.func,
    serverSave: PropTypes.func,
    serverShow: PropTypes.func,
    showCancel: PropTypes.func,
    serverIndex: PropTypes.func,
    serverFilter: PropTypes.func,
    create: PropTypes.func
  }).isRequired,
  employee: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string
    })),
    loading: PropTypes.bool,
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({}),
      paging: PropTypes.shape({
        current: PropTypes.number.isRequired
      }).isRequired,
      sortAttribute: PropTypes.string,
      sortDirection: PropTypes.string
    }).isRequired,
    initialIndexQuery: PropTypes.shape({}),
    selected: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  login: PropTypes.shape({
    user: PropTypes.shape({
      user_id: PropTypes.string
    }),
    geolocation: PropTypes.shape({
      country_name: PropTypes.string,
      region_name: PropTypes.string,
      time_zone: PropTypes.string
    })
  }).isRequired,
  canEdit: PropTypes.bool.isRequired,
  canView: PropTypes.bool.isRequired,
  location: PropTypes.shape({}).isRequired
};
export { Employees as EmployeesTest };
export default entityComposition(Employees, ['employee', 'login'], {
  canView: state => viewPermissionSelector('employee')(state),
  canEdit: state => editPermissionSelector('employee')(state),
  userID: state => state.login.user.user_id
});